export default __webpack_public_path__ + "static/media/thumbnail.23986ba3.png";